import { createFileRoute } from "@tanstack/react-router";
import OutdoorEnhancements from "@/pages/OutdoorEnhancements";
import { buildHead } from "@/lib/seo";

const areaServed = [
  { "@type": "City", name: "Fort Lauderdale" },
  { "@type": "City", name: "Coral Springs" },
  { "@type": "City", name: "Pembroke Pines" },
  { "@type": "City", name: "Weston" },
  { "@type": "City", name: "Miramar" },
  { "@type": "City", name: "Sunrise" },
  { "@type": "City", name: "Davie" },
  { "@type": "City", name: "Miami" },
  { "@type": "City", name: "Tampa" },
  { "@type": "City", name: "Orlando" },
];

export const Route = createFileRoute("/services/outdoor-enhancements")({
  head: () =>
    buildHead({
      title:
        "Outdoor Enhancements in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Water features, outdoor lighting, artificial turf, retaining walls, fencing, and pressure washing services in Fort Lauderdale, Coral Springs, Weston, and across Broward County. Family-owned. Free estimates.",
      path: "/services/outdoor-enhancements",
      jsonLd: [
        {
          "@context": "https://schema.org",
          "@type": "Service",
          serviceType: "Outdoor Enhancements",
          provider: {
            "@type": "HomeAndConstructionBusiness",
            name: "Precision Pavers & Pool Design",
            url: "https://precisionpaverspools.com/",
          },
          areaServed,
          url: "https://precisionpaverspools.com/services/outdoor-enhancements",
          description:
            "Expert Outdoor Enhancements services in Broward County, FL. Free estimates.",
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://precisionpaverspools.com/",
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Services",
              item: "https://precisionpaverspools.com/services",
            },
            {
              "@type": "ListItem",
              position: 3,
              name: "Outdoor Enhancements",
              item: "https://precisionpaverspools.com/services/outdoor-enhancements",
            },
          ],
        },
      ],
    }),
  component: OutdoorEnhancements,
});
